import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import NumberField from './NumberField';
import { formatCurrency, formatNumber } from '../utils/calculations';

const { FiTrendingUp } = FiIcons;

function PerformanceModel({ settings, calculations, onChange }) {
  return (
    <section className="panel performance-panel">
      <div className="section-heading">
        <div>
          <span className="section-kicker">Optional outcome model</span>
          <h2>Projected value and ROI</h2>
        </div>
        <div className="performance-badge">
          <SafeIcon icon={FiTrendingUp} />
          {calculations.roi.toFixed(1)}% ROI
        </div>
      </div>

      <div className="performance-grid">
        <NumberField
          label="Projected qualified leads"
          value={settings.projectedLeads}
          onChange={(value) => onChange('projectedLeads', value)}
          step={10}
        />
        <NumberField
          label="Conversion rate"
          value={settings.conversionRate}
          onChange={(value) => onChange('conversionRate', value)}
          suffix="%"
          step={0.5}
        />
        <NumberField
          label="Value per conversion"
          value={settings.valuePerConversion}
          onChange={(value) => onChange('valuePerConversion', value)}
          prefix="$"
          step={100}
        />
      </div>

      <div className="performance-results">
        <div>
          <span>Expected conversions</span>
          <strong>{formatNumber(calculations.convertedLeads)}</strong>
        </div>
        <div>
          <span>Projected attributable value</span>
          <strong>{formatCurrency(calculations.projectedValue)}</strong>
        </div>
        <p>
          This directional model is for planning only. Replace assumptions with
          your organization’s validated attribution and compliance methodology.
        </p>
      </div>
    </section>
  );
}

export default PerformanceModel;